var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"请选择柜型","size":"small"},on:{"change":_vm.getCty},model:{value:(_vm.contype),callback:function ($$v) {_vm.contype=$$v},expression:"contype"}},_vm._l((_vm.options),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.name,"value":item.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }